import { UserIdSchema } from "@core/domains/identity";
import { identity } from "@core/foundation/function";
import { ulid } from "@core/foundation/id";
import {
  createModel,
  createModelId,
  createModelSchemas,
  noModelUpdate,
} from "@core/foundation/model";
import { z } from "@core/zod";

import { ID_PREFIX } from "./shared/id-prefix.ts";
import { TaxonomyIdSchema } from "./shared/taxonomy-id.ts";

const { generateId: generateTagKindId, idSchema: TagKindIdSchema } =
  createModelId({ digestFn: ulid, idPrefix: ID_PREFIX.TAG_KIND });

export { TagKindIdSchema };

export type TagKindId = z.infer<typeof TagKindIdSchema>;

export const TagKind = createModel({
  create: (item, schema) => {
    return { ...schema.decode(item), id: generateTagKindId() };
  },
  schemas: createModelSchemas({
    base: z.object(
      {
        id: TagKindIdSchema,
        name: z.string(),
        principalId: UserIdSchema,
        taxonomyId: TaxonomyIdSchema,
      },
      {
        id: "The tag kind's permanent id, which a rename leaves unchanged.",
        name: "The tag kind's name.",
        principalId: "The id of the user the tag kind belongs to.",
        taxonomyId: "The id of the taxonomy the tag kind belongs to.",
      },
    ),
    derive: {
      create: schema => schema.omit({ id: true }),
      recovery: identity,
      update: noModelUpdate,
    },
  }),
  update: (item, update, schema) => {
    return { ...item, ...schema.decode(update) };
  },
});

export interface TagKind extends z.infer<typeof TagKind.schema> {}
